import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import { GroupContext } from './context';
import Item from './Item';
import { emptyFn } from '../../utils/helper';
var Group = (function (_super) {
    __extends(Group, _super);
    function Group() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, selectedColors = _a.selectedColors, label = _a.label, colors = _a.colors, labelClassName = _a.labelClassName, labelStyle = _a.labelStyle, hoverEffect = _a.hoverEffect, onChange = _a.onChange, onClickColor = _a.onClickColor, rest = __rest(_a, ["prefixCls", "className", "style", "children", "selectedColors", "label", "colors", "labelClassName", "labelStyle", "hoverEffect", "onChange", "onClickColor"]);
            var classes = classNames(prefixCls, className);
            var containerClasses = classNames(prefixCls + "-container");
            var labelClasses = classNames(prefixCls + "-label", labelClassName);
            return (h("div", __assign({ className: classes, style: style }, rest),
                label && h("div", { className: labelClasses, style: labelStyle }, label),
                h("div", { className: containerClasses },
                    h(GroupContext.Provider, { value: selectedColors }, colors === null || colors === void 0 ? void 0 :
                        colors.map(function (color) {
                            return h(Item, { key: color, color: color, hoverEffect: hoverEffect, onClick: function () { return _this.handleClick(color); } });
                        }),
                        children))));
        };
        return _this;
    }
    Group.prototype.handleClick = function (clickColor) {
        var _a = this.props, selectedColors = _a.selectedColors, onChange = _a.onChange, onClickColor = _a.onClickColor;
        onClickColor(clickColor);
        if (selectedColors.indexOf(clickColor) !== -1) {
            onChange(selectedColors.filter(function (selectedColor) { return selectedColor !== clickColor; }));
        }
        else {
            onChange(selectedColors.concat(clickColor));
        }
    };
    Group.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Group;
}(React.Component));
export default Group;
Group.defaultProps = {
    prefixCls: 'dui-colorpicker-group',
    selectedColors: [],
    onChange: emptyFn,
    onClickColor: emptyFn,
};
